import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { setTheme, selectTheme } from './store/slices/uiSlice';

// Layout
import Layout from './components/Layout';
import ProtectedRoute from './components/ProtectedRoute';
import AdminRoute from './components/AdminRoute';

// Pages
import Home from './pages/Home';
import Login from './pages/Login';
import Profile from './pages/Profile';
import UserProfile from './pages/UserProfile';
import AddPin from './pages/AddPin';
import EditPin from './pages/EditPin';
import Trending from './pages/Trending';
import About from './pages/About';
import PrivacyPolicy from './pages/PrivacyPolicy';
import Onboarding from './pages/Onboarding';
import Admin from './pages/Admin';
import AuthCallback from './pages/AuthCallback';
import ForgotPassword from './pages/ForgotPassword';
import NotFound from './pages/NotFound';

// Custom Toast
import ToastContainer from './components/Toast';

function App() {
  const dispatch = useDispatch();
  const theme = useSelector(selectTheme);

  useEffect(() => {
    // Initialize theme
    dispatch(setTheme(theme));
  }, []);

  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Layout />}>
          <Route index element={<Home />} />
          <Route path="login" element={<Login />} />
          <Route path="forgot-password" element={<ForgotPassword />} />
          <Route path="auth/callback" element={<AuthCallback />} />
          <Route path="trending" element={<Trending />} />
          <Route path="about" element={<About />} />
          <Route path="privacy-policy" element={<PrivacyPolicy />} />
          <Route path="user/:userId" element={<UserProfile />} />

          <Route element={<ProtectedRoute />}>
            <Route path="profile" element={<Profile />} />
            <Route path="add" element={<AddPin />} />
            <Route path="edit/:pinId" element={<EditPin />} />
            <Route path="onboarding" element={<Onboarding />} />
          </Route>

          <Route element={<AdminRoute />}>
            <Route path="admin" element={<Admin />} />
          </Route>

          <Route path="*" element={<NotFound />} />
        </Route>
      </Routes>

      <ToastContainer />
    </BrowserRouter>
  );
}

export default App;
